// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-checkbox.v-input {
  flex: 0 1 auto;
}
:where(.vuetify-styles) .v-checkbox .v-selection-control {
  min-height: var(--v-input-control-height);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCheckbox/VCheckbox.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,yCAAyC;AAC3C","sourcesContent":[".v-checkbox.v-input {\n  flex: 0 1 auto;\n}\n.v-checkbox .v-selection-control {\n  min-height: var(--v-input-control-height);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
